///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum GtthSNMPVersionEnum {
    V2C = 0,
    V3 = 1
}
